'use client'

import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore from "swiper";
import {Navigation, Scrollbar} from "swiper/modules";
import './industries.scss';
import 'swiper/css';
import {TIndustriesSliderProps} from "@/app/[locale]/common/components/Industries/types";

SwiperCore.use([Navigation, Scrollbar]);

export const IndustriesSlider = ({ data, slidesPerView = 3, renderSlide, navigationId }: TIndustriesSliderProps) => {
    const breakpoints = slidesPerView === 4 && {
        150: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        900: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1150: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    }

    return (
        <div className={'industries-slider'}>
            <Swiper
                slidesPerView={slidesPerView}
                breakpoints={breakpoints || {
                    150: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1050: {
                        slidesPerView: slidesPerView,
                        spaceBetween: 40,
                    },
                }}
                navigation={{
                    nextEl: `.industries-slider__custom-next-${navigationId}`,
                    prevEl: `.industries-slider__custom-prev-${navigationId}`,
                }}
                loop={true}
                speed={800}
                spaceBetween={40}
            >
                {
                    data.map((item, index: number) => (
                        <SwiperSlide key={index} className={'industries-slider__custom-slider'}>
                            { renderSlide(item, index) }
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    );
};